import AdminLayout from '../../../common/components/AdminLayout';

const Dashboard = () => {
    return <AdminLayout title="Dashboard"></AdminLayout>;
};

export default Dashboard;
